import { useNavigate } from "react-router-dom"
import { Typography } from "../Typography"
import arrowLeft from "@/assets/images/icons/arrowLeft.svg"

interface Props {
  title: string
}
const ListHeader = ({ title }: Props) => {
  const navigate = useNavigate()
  return (
    <div className="flex fixed top-0 right-0 left-0 justify-between items-center p-4 w-full h-14 bg-white min-w-[360px] max-w-[768px] mx-auto">
      <button onClick={() => navigate(-1)}>
        <img src={arrowLeft} alt="arrow Left" />
      </button>
      <Typography variant="h4">{title}</Typography>
      <div></div>
    </div>
  )
}

export default ListHeader
